if(typeof _.constant === 'undefined') { var e = new Error("Cannot find module '_.constant'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = _.constant;